module.exports = __webpack_public_path__ + "img/icon-outer-roll.41b05a8c.png";